import { Observable } from "rxjs";
import { Tag } from "../domain/models";
import { CreateUpdateTagRequest } from "../domain/requests";
import { Injectable } from "@angular/core";

@Injectable({providedIn: 'root'})
export abstract class TagRepository {
  abstract getTags(): Observable<Tag[]>;

  abstract getTagsLookup(): Observable<Tag[]>;

  abstract createEditTag(request: CreateUpdateTagRequest): Observable<boolean>;

  abstract deleteTag(id: string): Observable<boolean>;
}
